import React from 'react';

const SiteFooter = ({ className = '' }) => (
  <footer className={`relative z-10 border-t border-white/10 py-6 ${className}`}>
    <div className="max-w-7xl mx-auto px-6 text-center text-zinc-500 text-sm space-y-1">
      <p>Seatask © Copyright 2026 All Right Reserved</p>
      <p>Seatask Arcane AI · Crafted for seekers of meaning across every tide.</p>
    </div>
  </footer>
);

export default SiteFooter;
